import { useEffect } from "react";
import { Card, TextInput, Button, Label, Table, Checkbox } from "flowbite-react";
import usePermissions from "../hooks/usePermissions";
import { useReducerAsState } from "../hooks/useReducerAsState";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { profileSchema } from "../schemas/profile.schema";
import useProfiles from "../hooks/useProfiles";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import { routes } from "../routes";
import { PermissionsType } from "../types/permissions";

interface State {
    profilePermissions: Array<PermissionsType>;
}

const ProfileDetailsScreen = () => {    
    const { id } = useParams()
    const { permissions, fetchPermissions } = usePermissions()
    const { profile, createProfile, updateProfile, getProfile, loading } = useProfiles()

    const navigate = useNavigate();

    const { register, handleSubmit, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(profileSchema),
    });

    useEffect(() => {
        (async () => {
            await fetchPermissions({
                page:1,
                limit: 99999,
            })

            if(!id) return

            const itemId = parseInt(id)
            if(!isNaN(itemId)){
                await getProfile(itemId)
            }
        })();
        // eslint-disable-next-line
    },[id])

    // eslint-disable-next-line
   const [state, setState] = useReducerAsState<State>({
     profilePermissions : []
   })

   const onPermissionChange = (e: any, item: PermissionsType) => {
    const newPermissions = e.target.checked ? [...state.profilePermissions, item] : state.profilePermissions.filter((p) => p.slug !== item.slug);
    setState({profilePermissions: newPermissions})
    setValue("permissions",newPermissions)    
    }

    const save = async (data: any) => {
        const info = {
            name: data.name,
            permissions: data.permissions
        }

        const saved = profile ? await updateProfile(profile.id, info) : await createProfile(info)
        toast(saved ? "Perfíl guardado correctamente" : "Ocurrió un error al guardar el perfíl",{
            type: saved ? "success" : "error"
        });

        if(saved && isNaN(parseInt(id!))){
            navigate(`${routes.DASHBOARD}/${routes.PROFILES}`, {
                replace: true
            })
        }
    }

    useEffect(() => {
        if(!profile) return
        setValue("name", profile.title)
        setValue("permissions", profile.permissions)
        setState({profilePermissions: profile.permissions})
        // eslint-disable-next-line
    },[profile])

    return <div className="m-4">
        <div className="mb-4">
            <div className="flex flex-row justify-between">
                <h1>Detalles de perfíl</h1>
                <Button isProcessing={loading} disabled={loading} onClick={handleSubmit(save)}>Guardar perfíl</Button>
            </div>
        </div>
        <Card>
            <div className="flex flex-col mb-2">
                <Label className="mb-2">Nombre</Label>
                <TextInput 
                    placeholder="Escriba aquí"
                    {...register("name", {
                        value: profile?.title || ""
                    })}
                    helperText={errors && errors.name ? errors.name.message : ""}
                    required 
                    color={errors && errors.name ? "failure" : "gray"}
                />
            </div>
            <div className="flex flex-col mb-2">
                <Table className="bg-white-200 dark:bg-slate-200">
                    <Table.Head>
                        <Table.HeadCell>Permisos</Table.HeadCell>
                    </Table.Head>
                    <Table.Body>
                        {permissions && permissions.map((item) => <Table.Row key={item.id}>
                        <Table.Cell>
                            <div className="flex items-center gap-2">
                                <Checkbox id={item.slug} onChange={(e) => onPermissionChange(e,item)} checked={state.profilePermissions.some((p) => p.slug === item.slug)} />
                                <Label htmlFor={item.slug} className="flex">
                                    {item.name}
                                </Label>
                            </div>
                        </Table.Cell>
                        </Table.Row>
                        )}
                    </Table.Body>
                </Table>
            </div>
        </Card>

        </div>
}


export default ProfileDetailsScreen